import React from 'react'
import { Button } from 'components/Button/Button'
import styles from './SignupStep1.module.scss'
import { useNavigate } from 'react-router-dom'
import { PopupAddMetamask } from './PopupAddMetamask/PopupAddMetamask'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { updateAccount } from 'redux/rootSlice/rootSlice'
import { Attention } from 'components/Attention/Attention'


type Props = {
    onSubmit?: () => void;
}

export function SignupStep1(props: Props) {
    const [showPopupMetamask, setShowPopupMetamask] = React.useState(false)
    // const { account } = useAppSelector((state) => state.root)
    const [isReqCancel, setIsReqCancel] = React.useState(false)

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    function navigateToLogin() {
        navigate('/login')
    }

    function handleSubmit() {
        props.onSubmit()
    }

    function openPopupMetamask() {
        setShowPopupMetamask(true)
    }

    function closePopupMetamask() {
        setShowPopupMetamask(false)
    }

    function connectMetamask() {
        const { ethereum } = window

        if (ethereum) {
            ethereum.request({ method: 'eth_requestAccounts' })
                .then((accounts: string[]) => {
                    if (accounts.length > 0) {
                        dispatch(updateAccount(accounts[0]))
                        handleSubmit()
                    }
                })
                .catch((error: { code: number, message: string }) => {
                    if (error.code === 4001) {
                        // Пользователь отклонил запрос
                        console.log("User rejected the request.");
                        setIsReqCancel(true)
                    } else {
                        // Другие ошибки
                        openPopupMetamask()
                        // alert("Please install MetaMask!")
                        console.error("There was an error!", error);
                    }
                });

        } else {
            openPopupMetamask()
            // alert("Please install MetaMask!")
            console.log("Please install MetaMask!");
        }
    }

    React.useEffect(() => {
        const { ethereum } = window;
        if (ethereum) {
            ethereum.on('accountsChanged', (accounts: string[]) => {
                if (accounts.length > 0) {
                    dispatch(updateAccount(accounts[0]))
                } else {
                    dispatch(updateAccount(null))
                }
            });

            ethereum.on('chainChanged', (_chainId: string) => window.location.reload());
        } else {
            console.log("Please install MetaMask! use effect");
        }
    }, []);


    return (
        <>
            <div className={styles['wrapper']}>
                <div className={styles['title']}>Sign up for free</div>
                <div className={styles['description']}>
                    We recommend authorize with Metamask to send or receive support immediately.
                    {/* <br /> */}
                    {/* <br /> */}
                    {/* But it’s fine to start with Google. */}
                </div>
                <div className={styles['buttons']}>
                    <Button
                        size='m'
                        type='dark'
                        iconName='google'
                        onClick={handleSubmit}
                    >
                        Continue with Google
                    </Button>
                    <Button
                        size='m'
                        type='dark'
                        iconName='metamask'
                        onClick={connectMetamask}
                    >
                        Continue with Metamask
                    </Button>
                    {isReqCancel && (
                        <div className={styles['cancel-request']}>
                            <Attention color='red'>
                                You cancelled wallet connection. Please approve in Metamask
                            </Attention>
                        </div>
                    )}
                </div>
                <div className={styles['help']}>
                    <span>Already have an account? </span>
                    <span
                        className={styles['help__signin']}
                        onClick={navigateToLogin}>
                        Sign in here
                    </span>
                </div>
            </div>
            {showPopupMetamask && <PopupAddMetamask onClose={closePopupMetamask} />}
        </>
    );
}

